import { HttpClient } from '@angular/common/http';
import { ViewModelHelper } from 'app/shared/helpers/view-model-helper';
import { StandardFilter } from 'app/shared/prothesis-base-api-filters/standard-filter';
import { UuidCollectionViewModel } from 'app/shared/prothesis-base-api-view-models/uuid-collection.view-model';
import { VersionedViewModelBase } from 'app/shared/prothesis-base-api-view-models/versioned-view-model-base';
import { Observable } from 'rxjs';
import { ReadServiceBase } from './read-service-base';

export abstract class CrudServiceBase<
  TViewModel extends VersionedViewModelBase,
  TIndexViewModel,
  TFilter extends StandardFilter,
> extends ReadServiceBase<TViewModel, TIndexViewModel, TFilter> {
  public constructor(
    protected _httpClient: HttpClient,
    protected _actionPath: () => string,
    protected _apiUrl: string,
  ) {
    super(_httpClient, _actionPath, _apiUrl);
  }

  public addQuiet(modelToAdd: TViewModel): Observable<string> {
    return this._httpClient.post<string>(`${this._actionUrl}Quiet`, JSON.stringify(modelToAdd));
  }

  public updateQuiet(uuid: string | null | undefined, modelToUpdate: TViewModel | undefined): Observable<string> {
    return this._httpClient.put<string>(`${this._actionUrl}${uuid}/Quiet`, JSON.stringify(modelToUpdate));
  }

  protected _delete(uuid: string | null | undefined): Observable<void> {
    return this._httpClient.delete<void>(`${this._actionUrl}${uuid}`);
  }

  protected _deleteCollection(uuids: string[] | null | undefined): Observable<UuidCollectionViewModel> {
    const uuidCollectionViewModel = ViewModelHelper.toUuidCollectionViewModel(uuids);
    return this._httpClient.post<UuidCollectionViewModel>(`${this._actionUrl}DeleteCollection`, JSON.stringify(uuidCollectionViewModel));
  }
}
